import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { IoPrintOutline } from "react-icons/io5";
import { useReactToPrint } from "react-to-print";

const FormShowService = () => {
   const [service_id, setServiceId] = useState("");
   const [ticket_id, setTicketId] = useState("");
   const [description, setDesc] = useState("");
   const [contract_no, setContractNo] = useState("");
   const [clientName, setClientName] = useState("");
   const [address, setAddress] = useState("");
   const [email, setEmail] = useState("");
   const [phone, setPhone] = useState("");
   const [user_name, setUsername] = useState(""); 
   //const [created_by, setCreatedBy] = useState("");
   const [technician, setTechnician] = useState("");
   const [product_name, setProductName] = useState("");
   const [serialnumber, setSerialNumber] = useState("");
   const [url, setUrl] = useState("");
   const [manufacturer, setManufacturer] = useState("");
   const [repair_status, setRepairStatus] = useState("");

   const [companyname, setCompanyName] = useState("");
   const [companyaddress, setCompanyAddress] = useState("");
   const [companyemail, setCompanyEmail] = useState("");
   const [companyphone, setCompanyPhone] = useState("");
   const [companyfax, setCompanyFax] = useState("");
   const [urlc, setUrlC] = useState("");
   const [msg, setMsg] = useState("");
   const { id } = useParams();
   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
   const API_KEY = process.env.REACT_APP_API_KEY;

   const componentRef = useRef();
   
   const handlePrint = useReactToPrint({
      documentTitle: 'Title',
      contentRef: componentRef,
   })

   useEffect(() => {
      const getServiceById = async () => {
         try {
            const response = await axios.get(`${API_BASE_URL}/services/${id}`, {
               headers: {
                     'X-API-Key': API_KEY
               },
            });
            setTicketId(response.data.ticket.ticket_id);
            setDesc(response.data.description);
            setRepairStatus(response.data.repair_status);        
            setServiceId(response.data.service_id);
            setTechnician(response.data.technician);
            setProductName(response.data.ticket.product.name);
            setSerialNumber(response.data.ticket.product.serialnumber);
            setManufacturer(response.data.ticket.product.manufacturer);
            setUrl(response.data.ticket.product.url);
            setClientName(response.data.contract.client.name);
            setContractNo(response.data.contract.contract_no);
            setAddress(response.data.contract.client.address);
            setEmail(response.data.contract.client.email);
            setPhone(response.data.contract.client.phone);
            setUsername(response.data.user.name);
         } catch (error) {
            console.error(error);
            if (error.response) {
               setMsg(error.response.data.msg);
            }
         }
      };

      const getCompany = async () => {
         try {
            //get data sales contract
            const response = await axios.get(`${API_BASE_URL}/companies`, {
               headers: {
                     'X-API-Key': API_KEY
               },
            });  
            //console.log(response.data[0].name); 
            setCompanyName(response.data[0].name);
            setCompanyAddress(response.data[0].address);  
            setCompanyEmail(response.data[0].email);  
            setCompanyPhone(response.data[0].phone);  
            setCompanyFax(response.data[0].fax);
            setUrlC(response.data[0].url);
         } catch (error) {
               console.error(error);
               if (error.response) {
                  setMsg(error.response.data.msg);
               }
         }
      };
      getServiceById();
      getCompany();
   }, [id]);
   return (
      <div className="container">
         <div className="columns">           
           <div className="column is-full">
            <div className="buttons is-right">
               <button className="button is-link mr-2" onClick={handlePrint}><IoPrintOutline /> Print</button>
               <Link to="/services">
                  <button className="button is-black mr-4">
                     Back
                  </button>
               </Link>
            </div>
           </div>
         </div>
         <div className="pl-4 pr-4" ref={componentRef}>
            <div className="columns mt-2">
               <div className="column has-text-left is-2">
                  <figure className="image is-5by3">
                     <img src={urlc} alt="Preview Image" />
                  </figure>
               </div>
               <div className="column has-text-centered is-8">
                  <h1 className="title has-text-weight-bold is-size-5">{companyname}</h1>
                  <h3 className="title is-size-7">{companyaddress}<br/>Phone: {companyphone}, Fax: {companyfax}, Email: {companyemail}</h3>  
               </div>
            </div>
            <hr/>
            <h1 className="has-text-centered has-text-weight-bold is-size-5">DETAIL OF SERVICES</h1>
            <p className="has-text-centered is-size-6">SERVICE_ID: {service_id}</p>
            <h3 className="title is-size-6">DATA CUSTOMER/REPAIR</h3>  
            
            <div className="field is-horizontal">
               <div className="field-label is-normal has-text-right">
                  <label className="label">Ticket_ID:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={ticket_id} onChange={(e) => setTicketId(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <div className="field is-horizontal">
               <div className="field-label is-normal has-text-right">
                  <label className="label">Repair_Status:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input has-text-weight-bold" type="text" value={repair_status} onChange={(e) => setRepairStatus(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>       
            <div className="field is-horizontal">
               <div className="field-label is-normal has-text-right">
                  <label className="label">Customer_Name:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={clientName} onChange={(e) => setClientName(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>
            <div className="field is-horizontal">
               <div className="field-label is-normal has-text-right">
                  <label className="label">Contract_No:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={contract_no} onChange={(e) => setContractNo(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div>
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Address:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={address} onChange={(e) => setAddress(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Email:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={email} onChange={(e) => setEmail(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <div className="field is-horizontal">
               <div className="field-label is-normal">
                  <label className="label">Phone:</label>
               </div>
               <div className="field-body">
                  <div className="field">
                     <div className="control">
                        <input disabled className="input" type="text" value={phone || ""} onChange={(e) => setPhone(e.target.value)}/>
                     </div>
                  </div>
               </div>
            </div> 
            <h3 className="title is-size-6">DATA PRODUCT</h3>
            <table className="table is-striped is-fullwidth is-size-6">
               <thead>
                  <tr>
                     <th style={{width: "1%"}}>No</th>
                     <th className="has-text-centered">Image</th>
                     <th className="has-text-centered">Product_Name</th>
                     <th className="has-text-centered">Serial_Number</th>
                     <th className="has-text-centered">Merek/Manufacturer</th>
                     <th className="has-text-centered">Problem_Description</th>
                     <th className="has-text-centered">Qty</th>
                  </tr>
               </thead>
               <tbody>
                        <tr>
                           <td>{1}</td>
                           <td>
                              <figure className="image is-48x48">
                                 <img src={url} alt="Image" />
                              </figure>
                           </td>
                           <td>{product_name}</td>    
                           <td className="has-text-centered">{serialnumber}</td>
                           <td className="has-text-centered">{manufacturer}</td>          
                           <td>{description}</td>                                               
                           <td className="has-text-centered">
                            {1}
                           </td>
                        </tr>
               </tbody>
            </table> 
            <div className="columns">
            <div className="column is-half">
               Jakarta, {new Date().toLocaleDateString('id', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        })}
            </div>
            <div className="column has-text-right is-4">
               <span className="mr-3">
               Disetujui
               </span>
            </div>
            </div> 
            <div className="columns">
            <div className="column is-half">
               
            </div>
            <div className="column has-text-right is-4">
               <span className="mr-3">
               
               </span>
            </div>
            </div> 
            <div className="columns">
            <div className="column is-half">
               {user_name}
            </div>
            <div className="column has-text-right is-4">
               <span className="mr-3">
                  Customer
               </span>
            </div>
            </div>
         </div>                         
      </div>
   );
};

export default FormShowService;
